const MaintenancePage = ({ mode = "maintenance", isChecking = false, onRetry, supportUrl }) => {
  const isInitialCheck = mode === "checking";

  return (
    <section className="maintenance-page">
      <div className="maintenance-page__orb maintenance-page__orb--teal" aria-hidden="true"></div>
      <div className="maintenance-page__orb maintenance-page__orb--amber" aria-hidden="true"></div>
      <div className="maintenance-page__panel">
        <p className="maintenance-page__eyebrow">
          {isInitialCheck ? "Service Status" : "Bridge Maintenance"}
        </p>
        <h1>{isInitialCheck ? "Checking bridge availability" : "Bridge transfers are temporarily paused"}</h1>
        <p className="maintenance-page__lead">
          {isInitialCheck
            ? "We are confirming that the bridge API is live before allowing new requests."
            : "The bridge API is not responding normally right now. New transfers are blocked until service health is restored."}
        </p>
        <div className="maintenance-page__notice">
          <strong>Existing transfers remain safe.</strong>
          <span>
            If you already submitted a bridge, wait for service to return before checking status. Contact support if you need help.
          </span>
        </div>
        <div className="maintenance-page__actions">
          <button
            type="button"
            className="primary-button"
            onClick={onRetry}
            disabled={isChecking}
          >
            {isChecking ? "Checking..." : "Check again"}
          </button>
          {supportUrl ? (
            <a
              href={supportUrl}
              className="secondary-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact support
            </a>
          ) : null}
        </div>
        <p className="maintenance-page__footnote">
          New bridge requests will reopen automatically as soon as the API health check returns to normal.
        </p>
      </div>
    </section>
  );
};

export default MaintenancePage;
